import scBarChart from '../components/ScBarChart'
import httpManager from "../../util/common";
import scTable from '../components/ScTable'
import {entityOaid} from "../../util/util";

let customer_home = {
  components: {scBarChart, scTable},
  delimiters: ['{', '}'],
  props: {

  },
  data: () => {
    return {
      oaid: null,
      type:'customer',
      industry: "",
      officialName: "",
      cname: null,
      coaid: null,
      report: null,
      initCname: null,
      initCoaid: null,
    }
  },
  methods: {
    cleanCondition(){
      this.report = null
      this.cname = null
      // this.cname =this.initCname
    },
    recevie(oaid, name, report){
      if(!this.initCname){
        this.initCname = name
        this.initCoaid = oaid
      }
      this.cname = name
      this.coaid = oaid
      this.report = report
    },
    callIndicationTable(){
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid =result
      })
    }
  },
  mounted () {
    this.callIndicationTable()
  }
}
export default customer_home



// WEBPACK FOOTER //
// ./src/supplychain/js/sc_customers.js